import axios from './axios'
import config from '../config'

class SectionService{
    listSections(params) {
        return axios({
            url: config.backendUrl + '/common/sections',
            method: 'GET',
            params
        })
    }
    addSection(data) {
        return axios({
            url: config.backendUrl + '/common/sections',
            method: 'POST',
            data
        })
    }
    updateSection(data) {
        return axios({
            url: config.backendUrl + '/common/sections',
            method: 'PUT',
            data
        })
    }
    getSection(id, params) {
        return axios({
            url: config.backendUrl + '/common/sections/' + id,
            method: 'GET',
            params
        })
    }
    deleteSection(id) {
        return axios({
            url: config.backendUrl + '/common/sections/' + id,
            method: 'DELETE'
        })
    }
    listUserSectionSubscriptionSummaries(params) {
        return axios({
            url: config.backendUrl + '/project/user-section-subscriptions',
            method: 'GET',
            params
        })
    }
    checkUserSectionSubscription(userId,sectionId) {
        return axios({
            url: config.backendUrl + '/project/user-section-subscriptions/check',
            method: 'GET',
            params:{userId,sectionId}
        })
    }
    addUserSectionSubscription(data) {
        return axios({
            url: config.backendUrl + '/project/user-section-subscriptions',
            method: 'POST',
            data
        })
    }
    deleteUserSectionSubscriptionById(id) {
        return axios({
            url: config.backendUrl + '/project/user-section-subscriptions/' + id,
            method: 'DELETE'
        })
    }
    updateSectionNotifyConfig(data) {
        return axios({
            url: config.backendUrl + '/common/sections/notify-config',
            method: 'PUT',
            data
        })
    }
}
export default new SectionService()
